import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { PERCENTAGE_BARS_COLOR_SCHEME } from '../../constants';

class PercentageBar extends Component {
    static propTypes = {
        index:          PropTypes.number.isRequired,
        barPercentage:  PropTypes.number.isRequired,
        barMessage:     PropTypes.any,
        tooltipMessage: PropTypes.any,
    };

    render() {
        return (
            <div className={'bar bar-' + this.props.index}
                 style={{
                     width:           this.props.barPercentage + '%',
                     backgroundColor: PERCENTAGE_BARS_COLOR_SCHEME[this.props.index]
                 }}>
                <div>
                    {this.props.barMessage && <div>{this.props.barMessage}</div>}
                    {this.props.tooltipMessage &&
                    <div className={'tooltip arrow-top tooltip-' + this.props.index}>{this.props.tooltipMessage}</div>}
                </div>
            </div>
        )
    }
}

export default PercentageBar;



// WEBPACK FOOTER //
// ./src/scripts/reusable/PercentageBars/PercentageBar.jsx